import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from '../../../../store/middleware/apiActions';

const slice = createSlice({
	name: 'banks',
	initialState: {
		list: [],
		loading: false,
		lastFetch: null,
	},
	reducers: {
		banksRequestFailed: (banks, action) => {
			banks.loading = false;
		},
		banksRequested: (banks, action) => {
			banks.loading = true;
		},
		banksReceived: (banks, action) => {
			banks.list = action.payload.data;
			banks.loading = false;
			banks.lastFetch = Date.now();
		},
	},
});

export const {
	banksAdded,
	banksReceived,
	banksRequested,
	banksRequestFailed,
	searchTextChanged,
	banksUpdated,
	banksDeleted,
	banksRelated,
} = slice.actions;

export const loadBanks = () => (dispatch, getState) => {
	const { lastFetch, list, updated } = getState().decisionLogic.banks;

	var diffMs = Date.now() - lastFetch;
	var diffHrs = Math.floor((diffMs % 86400000) / 3600000);

	if (diffHrs < 4 && list.length > 0 && !updated) return;

	dispatch(
		apiCallBegan({
			api: 'hammurabi',
			url: '/dl/banks',
			onStart: banksRequested.type,
			onSuccess: banksReceived.type,
			onError: banksRequestFailed.type,
		})
	);
};

export default slice.reducer;
